var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from './model';
import DtoConverter from '../core/utils/dto-converter';
import { Photo } from './photo';
import { Product } from './product';
import { ProductVariant } from './product-variant';
import { CartItemAddon } from './cart-item-addon';
import { t } from '../core/utils/translation-helper';
var CartItem = /** @class */ (function (_super) {
    __extends(CartItem, _super);
    function CartItem(data) {
        var _this = _super.call(this, data) || this;
        if (data.photos) {
            _this.photos = DtoConverter.createList(Photo, data.photos);
        }
        if (data.product) {
            _this.product = new Product(data.product);
        }
        if (data.product_variant) {
            _this.product_variant = new ProductVariant(data.product_variant);
        }
        if (data.addons) {
            _this.addons = DtoConverter.createList(CartItemAddon, data.addons);
        }
        return _this;
    }
    CartItem.prototype.getName = function (forceLocale) {
        if (!this.product.translations) {
            return '';
        }
        var name = t('name', this.product.translations, forceLocale);
        if (this.product_variant && this.product_variant.translations) {
            name = name + " (" + t('name', this.product_variant.translations, forceLocale) + ")";
        }
        return name !== null && name !== void 0 ? name : '';
    };
    CartItem.prototype.getTotal = function () {
        var _a, _b;
        var total = 0;
        this.photos.forEach(function (item) {
            total += item.product_item.getPrice();
        });
        if (this.photos.length < this.product.minimum_payable) {
            total = total / this.photos.length * this.product.minimum_payable;
        }
        total += this.product.getBasePrice();
        if ((_a = this.addons) === null || _a === void 0 ? void 0 : _a.length) {
            this.addons.forEach(function (addon) { return total += addon.product_addon.getPrice(addon.quantity); });
        }
        total = (_b = total * this.quantity) !== null && _b !== void 0 ? _b : 1;
        return total;
    };
    return CartItem;
}(Model));
export { CartItem };
